<template>
    <div class="fast-search-input">
        <el-popover
            v-click-outside="closeSearchResultPanel"
            placement="bottom-start"
            :width="resultContentWidth"
            trigger="manual"
            popper-class="p-0 fast-search-popover"
            :value="displayResultPanel"
            @show="resultOpened"
        >
            <div v-if="loading" style="min-height: 50px" class="prelative">
                <preloader :display="loading" />
            </div>
            <div v-else>
                <div v-if="allResult" class="wp-10 px-5 py-3 bb-1">
                    <a href="javascript:;" class="link flex-level" @click="process"
                        ><i class="icon-chevron-left mr-2"></i>
                        {{ $l10n.__('Retour à la liste') }}</a
                    >
                </div>

                <div class="py-3">
                    <div v-if="noResult" class="fast-search-no-result flex-level">
                        <div class="wp-10 acenter">
                            <div class="m-auto pb-4">
                                <img
                                    src="/ressources/logged/img/dashboard/no-result-illustration.svg"
                                    alt=""
                                    width="127"
                                />
                            </div>
                            <div class="wp-7 m-auto wordbreak">
                                <span class="fs-3 gray-60">{{
                                    $l10n.__(
                                        'Aucun résultat ne semble correspondre à votre recherche, modifiez votre critère.',
                                    )
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <search-result
                        v-if="contacts && contacts.items && contacts.items.length > 0"
                        :data="contacts"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-contact :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="individuals && individuals.items && individuals.items.length > 0"
                        class="mt-3"
                        :data="individuals"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-third :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="companies && companies.items && companies.items.length > 0"
                        class="mt-3"
                        :data="companies"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-third :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="
                            opportunities && opportunities.items && opportunities.items.length > 0
                        "
                        class="mt-3"
                        :data="opportunities"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-opportunity :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="hasDocumentSearch"
                        class="mt-3"
                        :data="documentsData"
                        :all-result="allResult"
                        :group-by="salesDocuments.groupBy"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-sales-document :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="products && products.items && products.items.length > 0"
                        class="mt-3"
                        :data="products"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-product :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="tickets && tickets.items && tickets.items.length > 0"
                        class="mt-3"
                        :data="tickets"
                        :all-result="allResult"
                        @processByType="processByType"
                    >
                        <template #content="{ data }">
                            <search-result-support :data="data" />
                        </template>
                    </search-result>

                    <search-result
                        v-if="archived && archived.items && archived.items.length > 0"
                        class="mt-3"
                        :data="archived"
                        :all-result="true"
                    >
                        <template #title="{ data }">
                            <span class="red">{{ data.label }}</span>
                        </template>
                        <template #content="{ data }">
                            <component :is="data.component" :data="data" />
                        </template>
                    </search-result>
                </div>
            </div>

            <template #reference>
                <el-input
                    ref="search-input"
                    v-model="search"
                    suffix-icon="icon-search"
                    :placeholder="fastSearchPlaceholderLabel"
                    @input="process"
                    @focus="searchInputFocus = true"
                />
            </template>
        </el-popover>
    </div>
</template>

<script>
import SearchResult from 'vcomponents/fastsearch/SearchResult.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';

import SearchResultContact from 'vcomponents/fastsearch/templates/SearchResultContact.vue';
import SearchResultThird from 'vcomponents/fastsearch/templates/SearchResultThird.vue';
import SearchResultOpportunity from 'vcomponents/fastsearch/templates/SearchResultOpportunity.vue';
import SearchResultSalesDocument from 'vcomponents/fastsearch/templates/SearchResultSalesDocument.vue';
import SearchResultProduct from 'vcomponents/fastsearch/templates/SearchResultProduct.vue';
import SearchResultSupport from 'vcomponents/fastsearch/templates/SearchResultSupport.vue';

import ContactAdapter from 'Services/Adapters/SearchEngine/ContactAdapter';
import IndividualAdapter from 'Services/Adapters/SearchEngine/IndividualAdapter';
import CompanyAdapter from 'Services/Adapters/SearchEngine/CompanyAdapter';
import OpportunityAdapter from 'Services/Adapters/SearchEngine/OpportunityAdapter';
import SalesDocumentAdapter from 'Services/Adapters/SearchEngine/SalesDocumentAdapter';
import ProductAdapter from 'Services/Adapters/SearchEngine/ProductAdapter';
import ArchivedAdapter from 'Services/Adapters/SearchEngine/ArchivedAdapter';
import SupportTicketAdapter from 'Services/Adapters/SearchEngine/SupportTicketAdapter';
import RedactorAdapter from 'Services/Adapters/SearchEngine/RedactorAdapter';

import _ from 'lodash';

export default {
    components: {
        SearchResult,
        Preloader,
        SearchResultContact,
        SearchResultThird,
        SearchResultOpportunity,
        SearchResultSalesDocument,
        SearchResultProduct,
        SearchResultSupport,
    },
    props: [],
    data() {
        return {
            search: '',
            searchInputFocus: true,
            noResult: true,
            contacts: {},
            individuals: {},
            companies: {},
            opportunities: {},
            salesDocuments: {},
            products: {},
            archived: {},
            tickets: {},
            redactor: {},
            loading: false,
            allResult: false,
            resultContentWidth: '600',
            fastSearchPlaceholderLabel: this.$l10n.__('Rechercher une société, un contact'),
        };
    },
    computed: {
        displayResultPanel() {
            return this.searchInputFocus && this.search.length > 0;
        },
        hasDocumentSearch() {
            return (
                (this.salesDocuments &&
                    this.salesDocuments.items &&
                    this.salesDocuments.count > 0) ||
                (this.redactor && this.redactor.items && this.redactor.count > 0)
            );
        },
        documentsData() {
            return {
                ...this.salesDocuments,
                items: [...this.salesDocuments.items, ...this.redactor.items],
                count: this.salesDocuments.count + this.redactor.count,
            };
        },
    },
    methods: {
        resultOpened() {
            const input = document.getElementsByClassName('fast-search-input')[0];
            this.resultContentWidth = input?.clientWidth ?? '600';
        },
        closeSearchResultPanel() {
            this.searchInputFocus = false;
        },
        processByType(payload) {
            this.process(this.search, payload.type, true);
        },
        process: _.debounce(function (search, type = [], allResult = false) {
            if (this.search && this.search.length > 0) {
                this.searchInputFocus = true;
                this.loading = true;
                const params = {
                    q: this.search,
                };

                if (type.length > 0) {
                    params.type = type;
                }

                window.ApiClient.get(this.$router.resolve({ name: 'search' }).href, params).then(
                    (response) => {
                        this.noResult = response.data.data.length === 0;

                        this.contacts = new ContactAdapter(response.data).build();
                        this.individuals = new IndividualAdapter(response.data).build();
                        this.companies = new CompanyAdapter(response.data).build();
                        this.opportunities = new OpportunityAdapter(response.data).build();
                        this.products = new ProductAdapter(response.data).build();
                        this.archived = new ArchivedAdapter(response.data).build();
                        this.salesDocuments = new SalesDocumentAdapter(response.data).build();
                        this.tickets = new SupportTicketAdapter(response.data).build();
                        this.redactor = new RedactorAdapter(response.data).build();
                        this.allResult = allResult;
                        this.loading = false;
                    },
                );
            }
        }, 500),
    },
};
</script>

<style lang="scss">
.fast-search-popover {
    overflow-y: scroll;
    max-height: 600px;
}

.fast-search-input {
    flex: 1;
    max-width: 1040px;

    i {
        line-height: 32px;
    }
}

.fast-search-no-result {
    min-height: 300px;

    i {
        font-size: 72px;
    }
}

// to unset color on focus for old input search
#token-input-fast-search-input:focus {
    border: unset !important;
}
</style>
